import { ReactElement, useCallback, useRef, useState } from 'react';
import { Link } from '@tanstack/react-router';
import { DateTime } from 'luxon';

import { Issue, Article } from '@/constants';

import { Section } from '../Section';
import { useGetFeed } from '../Home.hooks';

export default function FeedIssue({
	title,
	issueId,
	showTitle,
	limit,
}: FeedProps) {
	const [domNode, setDomNode] = useState<HTMLUListElement | null>(null);
	const ref = useCallback((node: HTMLUListElement | null) => {
		if (node) {
			setDomNode(node);
		}
	}, []);

	const { isLoading, issue } = useGetFeed({ id: `${issueId}`, limit });

	if (!issue?.articles?.length && !isLoading) {
		return null;
	}

	return (
		<Section domNode={domNode} title={title}>
			{isLoading ? (
				<div>Loading</div>
			) : (
				<ul
					ref={ref}
					className="flex space-x-10 overflow-x-auto p-4 pt-0"
				>
					{issue?.articles
						? issue.articles.map(mapItem(issue, showTitle))
						: null}
				</ul>
			)}
		</Section>
	);
}

interface FeedProps {
	title: string;
	issueId: number;
	limit: number;
	showTitle: boolean;
}

function mapItem(issue: Issue, showTitle: boolean) {
	return (article: Article): ReactElement => {
		const { name, slug, id, thumbnail, created } = article;
		return (
			<li className="m-0 p-3" key={id}>
				<Link
					to="/issues/$id/$articleId"
					style={{ maxWidth: 590 }}
					params={{
						id: issue.slug ? issue.slug : issue.id,
						articleId: slug ? slug : id,
					}}
				>
					<img
						src={thumbnail}
						style={{
							aspectRatio: '5 / 3',
							width: 590,
							minWidth: 200,
						}}
						className="rounded-lg"
					></img>
					{created && (
						<h4 className="w-full mt-2 text-left text-xs font-bold">
							{DateTime.fromISO(`${created}`).toLocaleString(
								DateTime.DATE_FULL,
							)}
						</h4>
					)}
					{showTitle && (
						<small className="mt-2 text-left text-sm">
							{name['en']}
						</small>
					)}
				</Link>
			</li>
		);
	};
}
